import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export type SummaryTone = "default" | "positive" | "negative" | "warning";

export type SummaryMetric = {
  label: ReactNode;
  value: ReactNode;
  tone?: SummaryTone;
  title?: string;
};

export const summaryToneClassNames: Record<SummaryTone, string> = {
  default: "",
  positive: "app-summary-value--positive",
  negative: "app-summary-value--negative",
  warning: "app-summary-value--warning",
};

export function SummaryMetricGrid({
  metrics,
  layout = "home",
}: {
  metrics: SummaryMetric[];
  layout?: "home" | "portfolio" | "compact" | "two" | "four";
}) {
  return (
    <div className={`app-summary-grid app-summary-grid--${layout}`}>
      {metrics.map((metric, index) => (
        <div
          key={`${String(metric.label)}-${index}`}
          className="app-summary-cell"
        >
          <p className="app-section-label">{metric.label}</p>
          <div
            className={cn(
              "app-summary-value",
              summaryToneClassNames[metric.tone ?? "default"],
            )}
            title={metric.title}
          >
            {metric.value}
          </div>
        </div>
      ))}
    </div>
  );
}

export function SummaryStatGrid({ stats }: { stats: SummaryMetric[] }) {
  return (
    <div
      className={cn(
        "app-stat-grid",
        stats.length === 3 ? "app-stat-grid--3" : "app-stat-grid--4",
      )}
    >
      {stats.map((stat, index) => (
        <div key={`${String(stat.label)}-${index}`} className="app-stat-cell">
          <p className="app-section-label truncate whitespace-nowrap">
            {stat.label}
          </p>
          <div
            className={cn(
              "app-stat-value",
              summaryToneClassNames[stat.tone ?? "default"],
            )}
            title={stat.title}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
}
